import React from 'react';
export function Footer() {
  return <footer className="relative bg-slate-950 text-slate-400 py-12 border-t border-slate-900 overflow-hidden isolate" data-id="element-35">
      {/* Background image — Orange County coastal/skyline vibe */}
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-cover bg-center" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1534430480872-3498386e7856?auto=format&fit=crop&w=2000&q=80')"
    }} data-id="element-36" />
      {/* Dark overlay for readability */}
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-gradient-to-t from-slate-950 via-slate-950/90 to-slate-950/70" data-id="element-37" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-38">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-39">
          <div className="col-span-1 md:col-span-2" data-id="element-40">
            <div className="flex items-center gap-2 mb-4" data-id="element-41">
              <div className="w-8 h-8 bg-brand-600 rounded-lg flex items-center justify-center" data-id="element-42">
                <span className="text-white font-bold text-lg leading-none" data-id="element-43">
                  S
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-44">
                SEO Company OC
              </span>
            </div>
            <p className="text-sm max-w-xs mb-6" data-id="element-45">
              The performance SEO partner for Orange County marketing teams who
              demand revenue, not just rankings.
            </p>
          </div>

          <div data-id="element-46">
            <h4 className="text-white font-semibold mb-4" data-id="element-47">Company</h4>
            <ul className="space-y-2 text-sm" data-id="element-48">
              <li data-id="element-49">
                <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-50">
                  About Us
                </a>
              </li>
              <li data-id="element-51">
                <a href="#services" className="hover:text-brand-400 transition-colors" data-id="element-52">
                  Services
                </a>
              </li>
              <li data-id="element-53">
                <a href="#results" className="hover:text-brand-400 transition-colors" data-id="element-54">
                  Case Studies
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-56">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-57">
            <h4 className="text-white font-semibold mb-4" data-id="element-58">Contact</h4>
            <ul className="space-y-2 text-sm" data-id="element-59">
              <li data-id="element-60">Irvine, CA 92618</li>
              <li data-id="element-61">
                <a href="tel:9495550117" className="hover:text-brand-400 transition-colors" data-id="element-62">
                  (949) 555-0117
                </a>
              </li>
              <li data-id="element-63">
                <a href="mailto:hello@seocompanyoc.com" className="hover:text-brand-400 transition-colors" data-id="element-64">
                  hello@seocompanyoc.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-sm flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-65">
          <div data-id="element-66">
            &copy; {new Date().getFullYear()} SEO Company OC. All rights
            reserved.
          </div>
          <div className="flex gap-4" data-id="element-67">
            <a href="#" className="hover:text-white transition-colors" data-id="element-68">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-69">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}